import React from 'react'
import img404 from '../../assets/images/freepik__upload__12344.png'
import { Link } from 'react-router-dom'
import MobileBottomBar from '../Layout/MobileBottomBar';
const PageNotFound = () => {
    return (
        <>
            <section>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-sm-12 text-center">
                            <div className="no-found">
                                <div className="no-found-img">
                                    <img src={img404} alt='img' />
                                </div>
                                <h4>Oops! page not found</h4>
                                <p>
                                    Ut consequat ac tortor eu vehicula. Aenean accumsan purus eros.
                                    Maecenas sagittis tortor at metus mollis
                                </p>
                                <div>
                                    <Link to="/" className='thm-btn fill-btn'>Back To Home</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Mobile Bottom Bar */}
            <MobileBottomBar />
        </>
    )
}

export default PageNotFound